import { render, staticRenderFns } from "./ProductCopy.vue?vue&type=template&id=3be7043d&scoped=true&"
import script from "./ProductCopy.vue?vue&type=script&lang=js&"
export * from "./ProductCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be7043d",
  null
  
)

export default component.exports